import { ROUTES } from "../router";

export interface Permission extends Operations {
  id?: number;
  tenantID: number;
  name: string;
  entity: { id: number; name?: string };
  scope: { id: number; name?: string };
  role: { id: number; name?: string };
}
export interface Operations {
  create: boolean;
  read: boolean;
  update: boolean;
}

export interface PermissionSignature {
  tenantID: number;
  entityID: number;
  scopeID: number;
  roleID: number;
}

export interface EntityPermissions {
  contact: Operations;
  job: Operations;
  rule: Operations;
  property: Operations;
  property_group: Operations;
  user: Operations;
  permit: Operations;
  permit_type: Operations;
  pricing: Operations;
  permission: Operations;
  tenant: Operations;
}

export interface ScopedOperations {
  roleScope: Operations;
  assignedScope: Operations;
  createdScope: Operations;
}

export interface RoutePermission extends Operations {
  route: ROUTES;
}

export enum Operation {
  CREATE = "create",
  READ = "read",
  UPDATE = "update",
}

export const defaultEntityPermissions: EntityPermissions = {
  contact: { create: false, update: false, read: false },
  job: { create: false, update: false, read: false },
  rule: { create: false, update: false, read: false },
  property: { create: false, update: false, read: false },
  property_group: { create: false, update: false, read: false },
  user: { create: false, update: false, read: false },
  permit: { create: false, update: false, read: false },
  permit_type: { create: false, update: false, read: false },
  pricing: { create: false, update: false, read: false },
  permission: { create: false, update: false, read: false },
  tenant: { create: false, update: false, read: false },
};

export const superAdminPermissions: EntityPermissions = {
  contact: { create: true, update: true, read: true },
  job: { create: true, update: true, read: true },
  rule: { create: true, update: true, read: true },
  property: { create: true, update: true, read: true },
  property_group: { create: true, update: true, read: true },
  user: { create: true, update: true, read: true },
  permit: { create: true, update: true, read: true },
  permit_type: { create: true, update: true, read: true },
  pricing: { create: true, update: true, read: true },
  permission: { create: true, update: true, read: true },
  tenant: { create: true, update: true, read: true },
};
